import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Text } from '../../../Text';
import styles from '@dtsl/css-dropdown/dist/index.module.css';
const HelpText = props => {
  const {
    svg,
    helpText
  } = props;
  const helpTextClasses = classNames({
    [styles['help-text']]: true,
    [styles['sib-remove-space']]: !svg
  });
  return /*#__PURE__*/React.createElement(Text, {
    className: helpTextClasses,
    size: "sm",
    style: {
      color: 'var(--sib-color_content-secondary)'
    }
  }, helpText);
};
export default HelpText;
HelpText.defaultProps = {
  svg: null,
  helpText: ''
};
HelpText.propTypes = {
  svg: PropTypes.node,
  helpText: PropTypes.string
};